import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AtpConfig } from '../models/response/AtpConfig';
import { AtpSaveRequest } from '../models/request/AtpSaveRequest';
import { BaseResponse } from '../models/response/baseResponse';
import { map } from 'rxjs/operators';
import { AtpModifyRequest } from '../models/request/AtpModifyRequest';

@Injectable({
  providedIn: 'root'
})
export class AtpService {
  private httpClient = inject(HttpClient);
  private configService = inject(ConfigService);

  private apiLink: string;

  constructor() {
    /** ApiLink */
    this.apiLink = `${this.configService.config.apiEndpoint}`;
  }

  getAtpConfiguration(client_configuration_id: number): Observable<AtpConfig> {
    const url = `${this.apiLink}/client_configuration/atp/get`;
    let params = new HttpParams().set('id', client_configuration_id);

    return this.httpClient.get<BaseResponse<AtpConfig>>(url, { params }).pipe(map((res) => res.payload));
  }

  createAtpConfiguration(atpConfig: AtpSaveRequest): Observable<{ client_configuration_id: number }> {
    const url = `${this.apiLink}/client_configuration/atp/save`;

    return this.httpClient.post<{ client_configuration_id: number }>(url, atpConfig);
  }

  modifyAtpConfiguration(atpConfig: AtpModifyRequest): Observable<AtpConfig> {
    if (!atpConfig.client_configuration_id) {
      throw new Error('Invalid client_configuration_id');
    }

    const url = `${this.apiLink}/client_configuration/atp/modify`;

    return this.httpClient.post<AtpConfig>(url, atpConfig);
  }

  uploadArssConfiguration(voucher: any, file: File) {
    const data = new FormData();
    data.append('arssZipConfig', file);
    data.append('voucher', voucher);
    const url = `${this.apiLink}/client_configuration/atp/uploadArssConfig`;
    return this.httpClient.post<string>(url, data);
  }
}
